//AddVehicleModal.js

import React from 'react';
import PropTypes from 'prop-types';
import AddVehicleForm from '../Forms/AddVehicleForm';
import Modal from '../Modal/Modal';
import { useVehicles } from '../../context/VehicleContext';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';


const AddVehicleModal = ({ isOpen, onClose, onVehicleSaved, vehicle }) => {
  const { t } = useTranslation('userProfile');
  const { addVehicle, updateVehicle } = useVehicles();

  if (!isOpen) return null;

  const handleSubmit = async (vehicleData) => {
    let savedVehicle = null;
    if (vehicle) {
      // Editar vehículo existente
      savedVehicle = await updateVehicle(vehicle._id, vehicleData);
    } else {
      // Añadir nuevo vehículo
      savedVehicle = await addVehicle(vehicleData);
    }

    if (savedVehicle) {
      console.log('Vehículo guardado:', savedVehicle);
      onVehicleSaved(savedVehicle);
      onClose();
    } else {
      toast.error(t('garage.vehicle.errorSavingVehicle'));
    }
  };

  return (
    <Modal
      title={vehicle ? t('garage.vehicle.editVehicle') : t('garage.vehicle.addVehicle')}
      onClose={onClose}
      isOpen={isOpen}
      maxWidth="500px"
    >
      <AddVehicleForm
        onSubmit={handleSubmit}
        vehicle={vehicle}
        onClose={onClose}
      />
    </Modal>
  );
};

AddVehicleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onVehicleSaved: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

export default AddVehicleModal;